const checkEvenOdd = (number) => {
  return number % 2 === 0 ? 0 : 1;
};

// Function for product variants
const updateVariantsWidth = (variantsLength, maxLength, spaceTrim) => {
  const length = variantsLength;
  let variantsWidth = 0;

  if (length <= maxLength) {
    variantsWidth = (length + checkEvenOdd(length)) * (28 + spaceTrim);
  } else {
    variantsWidth = (maxLength - 1) * (28 + spaceTrim);
  }

  return variantsWidth;
};

export { updateVariantsWidth, checkEvenOdd };
